import { parse as parseCookie } from 'cookie-es'
import { getRequestHeader } from 'h3'

export function useRawCookies(name: string): { get: () => string | undefined } {
  if (import.meta.server) {
    const event = useRequestEvent()
    return { get: () => parseCookie((event ? getRequestHeader(event, 'cookie') : undefined) || '')?.[name] }
  }

  return { get: () => parseCookie(document.cookie)?.[name] }
}
